import React, { KeyboardEventHandler, useState } from 'react';
import { SearchIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Search';
import { useRouter } from 'next/router';
import { XIcon } from '@zola/zola-ui/src/components/SvgIconsV3/X';
import { ScreenReaderText } from '@zola/zola-ui/src/components/Modal/ModalV2.styles';

import { Container, SearchInput } from './FaqSearchInput.styles';
import { CloseButton } from '../FaqSearchDropdown/FaqSearchDropdown.styles';

export type FaqSearchInputProps = {
  className?: string;
  initialTerm?: string;
};

const FaqSearchInput = ({ className, initialTerm }: FaqSearchInputProps): JSX.Element => {
  const [value, setValue] = useState(initialTerm);
  const router = useRouter();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && value) {
      router.push(`/faq/search?term=${value}`).catch(() => undefined);
    }
  };

  const handleCloseClick = () => {
    setValue('');
  };

  const handleClosePressEnter: KeyboardEventHandler<HTMLButtonElement> = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      handleCloseClick();
    }
  };

  return (
    <Container className={className}>
      <SearchIcon height={20} width={20} />
      <SearchInput
        onChange={e => setValue(e.target.value)}
        value={value}
        onKeyDown={handleKeyDown}
        placeholder="Type your question..."
      />
      {value ? (
        <CloseButton onClick={handleCloseClick} onKeyDown={handleClosePressEnter}>
          <XIcon width={20} height={20} />
          <ScreenReaderText>Clear results</ScreenReaderText>
        </CloseButton>
      ) : null}
    </Container>
  );
};

export default FaqSearchInput;
